import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { MessageSquareWarning } from "lucide-react";
import GrievanceTable from "./GrievanceTable";
import { getThemeURL } from "../../../Services/EndPoints";
import { getData } from "../../../Services/Services";

const ROLE_SUBTITLE_MAP = {
  SEOC: "SEOC Dashboard - Manage and assign disaster complaints",
  DEOC: "DEOC Dashboard - Manage and assign disaster complaints",
  Citizen: "Citizen Disaster Complaint Dashboard",
};

const GrievanceMain = (props) => {
  // eslint-disable-next-line no-unused-vars
  const { t } = useTranslation();
  const [subtitle, setSubtitle] = useState("");

  useEffect(() => {
    getData(getThemeURL).then((res) => {
      const role = res?.[0]?.role_name;
      setSubtitle(ROLE_SUBTITLE_MAP[role] || "");
    }).catch(() => {});
  }, []);

  return (
    <>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500;600;700;800&display=swap');`}</style>
      <div style={{ margin: "8px", fontFamily: "'Poppins', 'Segoe UI', sans-serif" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            padding: "10px 14px",
            borderRadius: "10px",
            background: "linear-gradient(120deg, #2E6DA4 0%, #3B82C4 100%)",
            boxShadow: "0 2px 6px rgba(46,109,164,0.2)",
          }}
        >
          <div
            style={{
              width: "28px",
              height: "28px",
              borderRadius: "8px",
              background: "rgba(255,255,255,0.16)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <MessageSquareWarning size={14} color="#fff" />
          </div>
          <div>
            <div style={{ fontSize: "14px", fontWeight: 800, color: "#fff", letterSpacing: ".2px" }}>
              Helpdesk/Grievance
            </div>
            {subtitle && (
              <div style={{ fontSize: "10.5px", color: "rgba(255,255,255,0.75)", marginTop: "1px" }}>
                {subtitle}
              </div>
            )}
          </div>
        </div>
        <div style={{ marginTop: "10px", backgroundColor: "#fff", borderRadius: "10px" }}>
          <GrievanceTable />
        </div>
      </div>
    </>
  );
};

export default GrievanceMain;
